import { useQuery } from 'react-query'

import { request } from '../utils/api'
import { HTTPMethod, type Response } from '../utils/api.types'

type WebinarFormatDTO = {
  broadcasting_duration: number // 0
  broadcasting_duration_fmt: string // '0s'
  cancelled_p: boolean // false
  combined_avg_timeline_count: number //  0
  combined_avg_timeline_count_fmt: number | string //  0
  combined_avg_timeline_engagement: number // 0
  combined_avg_timeline_engagement_fmt: string // '0s'
  combined_avg_timeline_sessions: number // 0
  combined_avg_timeline_sessions_fmt: number | string // 0
  combined_conversion_conversion_rate: number //  1
  combined_conversion_conversion_rate_fmt: string // '100 %'
  combined_conversion_conversions: number // 0
  combined_conversion_conversions_fmt: string | number // 0
  combined_conversion_engagement: number // 0
  combined_conversion_engagement_fmt: string // '0s'
  combined_conversion_engagement_per_view: number // 0
  combined_conversion_engagement_per_view_fmt: string // '0s'
  combined_conversion_view_rate: number // 1
  combined_conversion_view_rate_fmt: string // '100 %'
  combined_conversion_views: number // 0
  combined_conversion_views_fmt: number | string // 0
  combined_conversion_visits: number // 0
  combined_conversion_visits_fmt: number | string // 0
  combined_total_identified_profiles: number // 0
  combined_total_identified_profiles_fmt: number | string //  0
  combined_total_profiles: number // 0
  combined_total_profiles_fmt: number | string // 0
  creation_date__date: string // 'Monday September 09, 2024'
  day_span: number // 1
  default_template_live_id: '' | number //
  description: string // '<p>Nam ut varius risus. Maecenas fermentum, nisl nec dapibus bibendum, quam ex ultrices lorem, sit amet egestas sem ex quis nibh. Nam placerat pretium ligula. Fusce volutpat lobortis quam a consectetur. Quisque vel tellus suscipit, lacinia justo sed, maximus nibh. Suspendisse eros sem, porta sed imperdiet at, ornare non nisi. Praesent facilisis elit fringilla eros cursus, eget dapibus ex varius. Nullam a ante pellentesque, luctus lectus et, lacinia odio.&nbsp;Nam ut varius risus. Maecenas fermentum, nisl nec dapibus bibendum, quam ex ultrices lorem, sit amet egestas sem ex quis nibh. Nam placerat pretium ligula. Fusce volutpat lobortis quam a consectetur. Quisque vel tellus suscipit, lacinia justo sed, maximus nibh. Suspendisse eros sem, porta sed imperdiet at, ornare non nisi. Praesent facilisis elit fringilla eros cursus, eget dapibus ex varius. Nullam a ante pellentesque, luctus lectus et, lacinia odio.</p><p><br></p>'
  description_html: string // '<p>Nam ut varius risus. Maecenas fermentum, nisl nec dapibus bibendum, quam ex ultrices lorem, sit amet egestas sem ex quis nibh. Nam placerat pretium ligula. Fusce volutpat lobortis quam a consectetur. Quisque vel tellus suscipit, lacinia justo sed, maximus nibh. Suspendisse eros sem, porta sed imperdiet at, ornare non nisi. Praesent facilisis elit fringilla eros cursus, eget dapibus ex varius. Nullam a ante pellentesque, luctus lectus et, lacinia odio.&nbsp;Nam ut varius risus. Maecenas fermentum, nisl nec dapibus bibendum, quam ex ultrices lorem, sit amet egestas sem ex quis nibh. Nam placerat pretium ligula. Fusce volutpat lobortis quam a consectetur. Quisque vel tellus suscipit, lacinia justo sed, maximus nibh. Suspendisse eros sem, porta sed imperdiet at, ornare non nisi. Praesent facilisis elit fringilla eros cursus, eget dapibus ex varius. Nullam a ante pellentesque, luctus lectus et, lacinia odio.</p>\n<p><br></p>\n'
  description_text: string // 'Nam ut varius risus. Maecenas fermentum, nisl nec dapibus bibendum, \nquam ex ultrices lorem, sit amet egestas sem ex quis nibh. Nam \nplacerat pretium ligula. Fusce volutpat lobortis quam a consectetur. \nQuisque vel tellus suscipit, lacinia justo sed, maximus nibh. \nSuspendisse eros sem, porta sed imperdiet at, ornare non nisi. \nPraesent facilisis elit fringilla eros cursus, eget dapibus ex varius. \nNullam a ante pellentesque, luctus lectus et, lacinia odio. Nam ut \nvarius risus. Maecenas fermentum, nisl nec dapibus bibendum, quam ex \nultrices lorem, sit amet egestas sem ex quis nibh. Nam placerat \npretium ligula. Fusce volutpat lobortis quam a consectetur. Quisque \nvel tellus suscipit, lacinia justo sed, maximus nibh. Suspendisse eros \nsem, porta sed imperdiet at, ornare non nisi. Praesent facilisis elit \nfringilla eros cursus, eget dapibus ex varius. Nullam a ante \npellentesque, luctus lectus et, lacinia odio.\n'
  description_trunc: string // 'Nam ut varius risus. Maecenas fermentum, nisl nec dapibus bibendum, quam ex ultrices lorem, sit amet egestas sem ex quis nibh. Nam placerat pretium ligula. Fusce volutpat lobortis quam a consectetur. Quisque vel tellus suscipit, lacinia justo sed, maximus nibh. Suspendisse eros sem, porta sed...'
  draft_p: boolean // true
  duration_of_published_recordings: number // 0
  duration_of_published_recordings_fmt: string // '0s'
  enable_ondemand_p: boolean // true
  end_date: string // '2024-10-26 00:30:00'
  end_date__date: string // 'Saturday October 26, 2024'
  end_date__time: string // '00:30'
  end_date_epoch: string // 1729895400
  link: string // 'https://demo.ranguinc.com/webinarseries-the-webinar-series/a8ec727ddbb2f84e53bc'
  live_average_engagement: string // '0.0'
  live_average_engagement_fmt: string // ''
  live_avg_timeline_count: number // 0
  live_avg_timeline_count_fmt: number | string // 0
  live_avg_timeline_engagement: number // 0
  live_avg_timeline_engagement_fmt: string // '0s'
  live_avg_timeline_sessions: number // 0
  live_avg_timeline_sessions_fmt: number | string // 0
  live_conversion_conversion_rate: number // 1
  live_conversion_conversion_rate_fmt: string // '100 %'
  live_conversion_conversions: number // 0
  live_conversion_conversions_fmt: number | string // 0
  live_conversion_engagement: number // 0
  live_conversion_engagement_fmt: string // '0s'
  live_conversion_engagement_per_view: number // 0
  live_conversion_engagement_per_view_fmt: string // '0s'
  live_conversion_view_rate: number // 1
  live_conversion_view_rate_fmt: string // '100 %'
  live_conversion_views: number // 0
  live_conversion_views_fmt: number | string // 0
  live_conversion_visits: number // 0
  live_conversion_visits_fmt: number | string // 0
  live_date: string // '2024-10-26 00:00:00'
  live_date__date: string // 'Saturday October 26, 2024'
  live_date__time: string //  '00:00'
  live_date_epoch: number //  1729893600
  live_engagement: number // 0
  live_engagement_fmt: string // '0s'
  live_label: string // 'Draft'
  live_peak_viewers: number // 0
  live_peak_viewers_fmt: number | string // 0
  live_series_id: number // 8641182
  live_status: string // 'upcoming'
  live_total_identified_profiles: number // 0
  live_total_identified_profiles_fmt: number | string // 0
  live_total_profiles: number // 0
  live_total_profiles_fmt: number | string //  0
  live_total_viewers: number // 0
  live_total_viewers_fmt: number | string // 0
  locale: string //  'en_US'
  name: string // 'WebinarSeries: the webinar series'
  number_of_attachment_downloads: number // 0
  number_of_attachment_downloads_fmt: number | string //  0
  number_of_attachments: number // 0
  number_of_attachments_fmt: number | string // 0
  number_of_chat_messages: number //  0
  number_of_chat_messages_fmt: number | string //  0
  number_of_comments: number // 0
  number_of_comments_fmt: number | string //  0
  number_of_poll_votes: number //  0
  number_of_poll_votes_fmt: number | string // 0
  number_of_polls: number // 0
  number_of_polls_fmt: number | string //  0
  number_of_published_recordings: number //  0
  number_of_published_recordings_fmt: number | string //  0
  number_of_questions: number //  0
  number_of_questions_fmt: number | string //  0
  number_of_recordings: number // 0
  number_of_recordings_fmt: number | string // 0
  number_of_sessions: number // 1
  number_of_sessions_fmt: number | string // 1
  number_of_draft_sessions: number // 1
  number_of_draft_sessions_fmt: number | string // 1
  primary_timezone: string // 'Europe/Copenhagen'
  private_p: boolean // true
  recording_avg_timeline_count: number //  0
  recording_avg_timeline_count_fmt: number | string //  0
  recording_avg_timeline_engagement: number //  0
  recording_avg_timeline_engagement_fmt: string // '0s'
  recording_avg_timeline_sessions: number // 0
  recording_avg_timeline_sessions_fmt: number | string //  0
  recording_conversion_conversion_rate: number //  1
  recording_conversion_conversion_rate_fmt: string // '100 %'
  recording_conversion_conversions: number //  0
  recording_conversion_conversions_fmt: number | string // 0
  recording_conversion_engagement: number // 0
  recording_conversion_engagement_fmt: string // '0s'
  recording_conversion_engagement_per_view: number //  0
  recording_conversion_engagement_per_view_fmt: string //  '0s'
  recording_conversion_view_rate: number //  1
  recording_conversion_view_rate_fmt: string // '100 %'
  recording_conversion_views: number // 0
  recording_conversion_views_fmt: number | string // 0
  recording_conversion_visits: number // 0
  recording_conversion_visits_fmt: number | string //  0
  recording_duration: number // 0
  recording_duration_fmt: string //  '0s'
  recording_engagement_minutes: number // 0
  recording_engagement_minutes_fmt: string // '0s'
  recording_total_identified_profiles: number //  0
  recording_total_identified_profiles_fmt: number | string //  0
  recording_total_profiles: number // 0
  recording_total_profiles_fmt: number | string //  0
  recording_view_count: number //  0
  recording_view_count_fmt: number | string // 0
  recurrence_rule: string
  recurrence_start_time: string
  recurrence_end_time: string
  registration_mode: 'subscription' | 'selection' // 'subscription'
  registration_page_link: string // ''
  schedule_mode: 'none' | 'limited' | 'full' // 'full'
  series_type: string // 'series'
  series_type_fmt: string // 'Webinar Series'
  short_description: string
  start_date: string //  '2024-10-26 00:00:00'
  start_date__date: string // 'Saturday October 26, 2024'
  start_date__time: string //  '00:00'
  start_date_epoch: number //  1729893600
  streaming_duration: number //  0
  streaming_duration_fmt: string // '0s'
  tagline: string
  thumbnail_photo_id: number | '' // 8641183
  thumbnail_stock_p: boolean // true
  thumbnail_url: string // '/7340/8641183/165f1331518333229c3dc5ca162602ed/large/download-2-thumbnail.jpg'
  timezone_offset: number // 2
  token: string // 'a8ec727ddbb2f84e53bc'
  trailer_embed_code: string // ''
  trailer_photo_id: number | '' // ""
  trailer_photo_title: string // ''
  trailer_token: string // ''
  updated_date__date: string // 'Thursday September 26, 2024'
  url_stub: string // 'webinarseries-the-webinar-series'
  series_format: 'series-recurring' | 'series-timelimited' | 'series-episodic'
  series_format_fmt: string
}

type WebinarFormat = {
  id: number
  type: string
  typeFormatted: string
  token: string
  name: string
  descriptionTruncated: string
  descriptionFull: string
  descriptionHtml: string
  link: string
  liveStatus: string
  liveLabel: string
  registrationPageLink: string
  shortDescription: string
  startDate: string
  startTime: string
  endDate: string
  endTime: string
  scheduleMode: 'none' | 'limited' | 'full'
  isPrivate: boolean
  isDraft: boolean
  isCancelled: boolean
  locale: string
  tagline: string
  timezone: string
  thumbnailId: number | undefined
  thumbnailUrl: string
  templateId: number | undefined
  trailerId: number | undefined
  isOnDemand: boolean
  registrationMode: 'subscription' | 'selection'
  conversionRate: string
  recurrenceRule: string | undefined
  recurrenceStartTime: string | undefined
  recurrenceEndTime: string | undefined
  attendanceRate: string
  pageViews: string | number
  registrantNumber: string | number
  attendeeNumber: string | number
  sessionCount: number
  startDateTime: string
  numberOfSessionsFmt: string | number
  engagementFmt: string
  liveDate: string
  thumbnailExists: boolean
  engagement: number
  seriesFormat: 'series-recurring' | 'series-timelimited' | 'series-episodic'
  seriesFormatFmt: string
  draftSessionCount: number
  draftSessionCountFmt: string | number
}

const mapDTOtoWebinarFormat = (dto: WebinarFormatDTO): WebinarFormat => {
  return {
    id: dto.live_series_id,
    tagline: dto.tagline,
    type: dto.series_type,
    typeFormatted: dto.series_type_fmt,
    name: dto.name,
    token: dto.token,
    descriptionTruncated: dto.description_trunc,
    descriptionFull: dto.description_text,
    descriptionHtml: dto.description_html,
    link: dto.link,
    liveStatus: dto.live_status,
    liveLabel: dto.live_label,
    registrationPageLink: dto.registration_page_link,
    scheduleMode: dto.schedule_mode,
    isPrivate: dto.private_p,
    isDraft: dto.draft_p,
    isCancelled: dto.cancelled_p,
    locale: dto.locale,
    timezone: dto.primary_timezone,
    thumbnailId:
      dto.thumbnail_photo_id === '' ? undefined : dto.thumbnail_photo_id,
    thumbnailUrl: dto.thumbnail_url,
    trailerId: dto.trailer_photo_id === '' ? undefined : dto.trailer_photo_id,
    shortDescription: dto.short_description,
    startDate: dto.start_date__date,
    startTime: dto.start_date__time,
    endDate: dto.end_date__date,
    endTime: dto.end_date__time,
    isOnDemand: dto.enable_ondemand_p,
    registrationMode: dto.registration_mode,
    conversionRate: dto.combined_conversion_conversion_rate_fmt,
    attendanceRate: dto.combined_conversion_view_rate_fmt,
    pageViews: dto.combined_conversion_visits_fmt,
    registrantNumber: dto.combined_conversion_conversions_fmt,
    attendeeNumber: dto.combined_conversion_views_fmt,
    sessionCount: dto.number_of_sessions,
    startDateTime: dto.start_date__time,
    numberOfSessionsFmt: dto.number_of_sessions_fmt,
    engagementFmt: dto.combined_conversion_engagement_fmt,
    liveDate: dto.live_date,
    thumbnailExists: dto.thumbnail_stock_p,
    engagement: dto.combined_conversion_engagement,
    seriesFormat: dto.series_format,
    seriesFormatFmt: dto.series_format_fmt,
    draftSessionCount: dto.number_of_draft_sessions,
    draftSessionCountFmt: dto.number_of_draft_sessions_fmt,
    recurrenceRule: dto.recurrence_rule || undefined,
    recurrenceStartTime: dto.recurrence_start_time || undefined,
    recurrenceEndTime: dto.recurrence_end_time || undefined,
    templateId: dto.default_template_live_id || undefined,
  }
}
interface GetWebinarFormatListRequest {
  live_series_id?: number
  token?: string
  include_total_count_p: boolean
  size?: number
}

interface GetWebinarFormatListResponse extends Response {
  data: WebinarFormatDTO[]
}

const getWebinarFormatList = (id?: number, token?: string) =>
  request<GetWebinarFormatListRequest, GetWebinarFormatListResponse>({
    url: '/api/2/live/series/list',
    method: HTTPMethod.GET,
    data: {
      live_series_id: id,
      token,
      include_total_count_p: true,
      size: 1,
    },
  })

const useWebinarFormatQuery = (webinarFormatId?: number, token?: string) => {
  return useQuery({
    queryKey: ['webinar-format', 'room', webinarFormatId],
    queryFn: async () => {
      const { data } = await getWebinarFormatList(webinarFormatId, token)

      const webinarFormat = data.at(0)
      return webinarFormat ? mapDTOtoWebinarFormat(webinarFormat) : undefined
    },
    staleTime: 10 * 60 * 1e3, // 10 minutes
    cacheTime: 10 * 60 * 1e3, // 10 minutes
    enabled: !!webinarFormatId,
  })
}

export { useWebinarFormatQuery }
